<template>
    <div v-if="text" class="d-flex gap-2 align-items-start">
        <div v-html="truncatedHtml"></div>
        <ButtonIcon
            v-if="isTruncated"
            v-b-tooltip.hover.noninteractive
            :title="buttonTitle"
            size="sm"
            icon="eye"
            variant="link"
            class="p-0 mb-auto"
            pill
            @click="showFullDescription"
        />
    </div>
</template>

<script>
    import truncate from 'truncate-html';
    import ButtonIcon from '@/components/common/ButtonIcon.vue';

    export default {
        name: 'TruncatedTextModal',
        components: { ButtonIcon },
        props: {
            modalTitle: {
                type: String,
                default: '',
            },
            buttonTitle: {
                type: String,
                default: '',
            },
            text: {
                type: String,
                required: true,
            },
            length: {
                type: Number,
                default: 50,
            },
            truncateOptions: {
                type: Object,
                default: () => ({ ellipsis: '...', excludes: 'img' }),
            },
        },
        computed: {
            truncatedHtml() {
                return truncate(this.text, this.length, this.truncateOptions);
            },
            isTruncated() {
                const raw = truncate(this.text, this.length, { ...this.truncateOptions, ellipsis: '' });
                return this.text.length > raw.length;
            },
        },
        methods: {
            showFullDescription() {
                const h = this.$createElement;
                const titleVNode = h('div', {
                    domProps: { innerHTML: this.modalTitle },
                });
                const bodyVNode = h('div', {
                    domProps: { innerHTML: this.text },
                    class: ['overflow-auto', 'height-min-200'],
                });
                this.$bvModal.msgBoxConfirm([bodyVNode], {
                    title: [titleVNode],
                    size: 'xl',
                    okTitle: this.$t('close'),
                    cancelTitle: '',
                    html: true,
                    centered: true,
                    hideHeaderClose: false,
                    hideFooter: true,
                    bodyClass: 'overflow-auto height-min-200',
                    footerClass: 'd-none',
                });
            },
        },
    };
</script>
